module.exports = __webpack_public_path__ + "media/images/warning-8a145a58e79b5d179a4d583609c97829.svg";